import type { ReactNode } from "react";
import { createPortal } from "react-dom";

export default function Modal({
  id,
  children,
}: {
  id: string;
  children: ReactNode;
}) {
  if (typeof window === "undefined") return <></>;
  return createPortal(
    <>
      <input type="checkbox" id={id} className="modal-toggle" />
      <label htmlFor={id} className="modal cursor-pointer">
        <label className="modal-box relative">{children}</label>
      </label>
    </>,
    window.document.body,
  );
}
